<div class="modal-header">
  <h4 class="modal-title pull-left">Do you really want to <span style="color:red;">Delete</span> User?</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body" *ngIf="user">
  <div class="row">

    <div class="col-sm-12 form-group">
      <label style="font-weight: normal;">
				Please enter
        <strong style="color: red;" *ngIf="user.getName()">{{user.getName()}}</strong>
        <strong style="color: red;" *ngIf="!user.getName()">{{user.ID}}</strong>
        to confirm deletion
      </label>

      <input type="text" [placeholder]="user.getName() ? user.getName() : user.ID" class="form-control"
        name="deleteName" [(ngModel)]="deleteName" />
    </div>

  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" (click)="onConfirm()" [disabled]="deleteName != user?.getName() && (deleteName != user?.ID+'')">
    Delete
  </button>
</div>
